var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$route.path.indexOf('_editor') === -1)?_c('alllist',{ref:"alllist",attrs:{"get-status":_vm.alllist}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }